import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const loginUserTenantAPI = createAsyncThunk(
  'co-users/login',
  async ({ t_id, ...requestHeaders }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${ROOT_URL}/co-users/login/${t_id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestHeaders),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);


const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const loginUserTenant = createSlice({
  name: 'loginUserTenant',
  initialState,
  reducers: {
    resetAgentUser: (state) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: false,
      isCompleted: false,
      response: [],
      error: null,
    }),
  },
  extraReducers: {
    [loginUserTenantAPI.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [loginUserTenantAPI.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [loginUserTenantAPI.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export const { resetAgentUser } = loginUserTenant.actions;
export default loginUserTenant;
